<template>
  <div class="audio-item-box" ref="refMoreListBox" v-if="props.renderType == 'create'">
    <!-- <div style="color: #fff; font-size: 12px; margin-bottom: 4px">
      {{ renderData.url }}
    </div> -->
    <AudioPlayer
      ref="refPlayer"
      :url="renderData.url"
      :duration="renderData.duration"
      @syncDuration="syncDuration"
      @syncPlayState="syncPlayState"
      @syncLoadingState="syncLoadingState"
      @syncProgress="syncProgress"
      @curPlayEnded="onCurPlayEnded"
      v-model:isGenerating="renderData.isGenerating"
    >
      <div
        class="audio-item"
        :class="{
          active: renderData.isCurPlay,
          'audio-item-mobile':
            createRenderType == 'mobile' || renderData.itemWidth < MIN_ITEM_WIDTH,
          [`audio-item-mobile--${props.listRenderType}`]: true,
        }"
      >
        <div class="audio-item-info-play-box">
          <div class="audio-item-play-status fn-inline pointer" v-if="!props.item?.is_played"></div>
          <div
            class="audio-item-cover-op-box fn-inline pointer"
            :class="{
              'isplay-true': renderData.isplay,
              'isplay-false': !renderData.isplay,
              'generate-loading': props.pitem?.state == 2,
              disabled: props.pitem?.state == 2 && !props.item.stream_key,
              [`generate-loading-play`]: props.pitem?.state == 2 && props.item.stream_key,
            }"
          >
            <LazyLoadImg
              :src="props.item?.cover ? getObjectStorageFullUrl(props.item?.cover) : defaultCover"
            ></LazyLoadImg>
            <div class="audio-item-cover-op flex-center" @click.stop="doTogglePlay">
              <div class="audio-item-cover-op-bg flex-center">
                <span
                  class="rotate-loading"
                  v-if="props.pitem?.state == 2 && !props.item.stream_key"
                >
                </span>
                <i class="block play"></i>
                <div class="playing">
                  <LoaderWave :animation="renderData.isplay"></LoaderWave>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="audio-item-info-wraper flex1 flex">
          <div
            class="audio-item-info pointer"
            :class="{
              'disabled-op': tools.isProd() && props.pitem?.state == 2 && !props.item.stream_key,
              disabled:
                tools.isProd() &&
                props.pitem?.state == 2 &&
                !props.item.stream_key &&
                !(
                  [2, 3].includes(props.pitem?.generation_method) &&
                  !props.item.stream_key &&
                  !props.item?.mp3_url
                ),
            }"
            @click="doGoDetail"
          >
            <div class="audio-item-title-version">
              <div class="audio-item-title olh" v-if="!renderData.isEditTitle">
                {{ props.item?.title ?? "" }}
              </div>
              <div
                class="audio-item-model"
                v-if="props.pitem?.model && !renderData.isEditTitle"
                :class="props.pitem?.model?.split(' ').pop()"
              >
                {{ props.pitem?.model?.split(" ").pop() }}
              </div>
              <div class="audio-item-version" v-if="!renderData.isEditTitle">
                {{ (props.item?.recall ? "recall " : "") + `V${props.item?.version}` }}
              </div>
              <div
                class="audio-item-upload-type"
                v-if="!renderData.isEditTitle && props.pitem?.is_generated_from_uploaded_file"
              >
                {{ $$t("editor.uploaded") }}
              </div>
              <div
                class="audio-item-edit-type"
                v-if="!renderData.isEditTitle && getEditorType(props.pitem)"
              >
                {{ getEditorType(props.pitem) }}
              </div>
              <div
                class="audio-item-published-tag"
                v-if="[1, 3, 4].includes(props.item?.publish_state)"
              >
                <div class="audio-item-published-tag-status">
                  <div class="audio-item-published-tag-status-text">
                    {{ $$t("create.published") }}
                  </div>
                  <div class="audio-item-published-tag-status-border"></div>
                </div>
                <div class="audio-item-published-tag-text">
                  {{ $$t("create.published") }}
                </div>
              </div>

              <!-- <div
                class="audio-item-non-ownership"
                v-if="props.item?.credit_type == 2"
              >
                {{ $$t("create.non_ownership") }}
              </div> -->
              <div class="audio-item-edit" v-if="renderData.isEditTitle" @click.stop>
                <input
                  @click.stop
                  ref="refInput"
                  :value="renderData.title"
                  @input="onInput"
                  @blur.native="onBlur"
                  :placeholder="$$t('create.enter_song_title')"
                  @compositionstart="handleCompositionStart"
                  @compositionend="handleCompositionEnd"
                />
              </div>
            </div>
            <div
              class="audio-item-generate-progress-box"
              v-if="
                [2, 3].includes(props.pitem?.generation_method) &&
                props.pitem?.is_generated_from_uploaded_file &&
                !props.item?.stream_key &&
                !props.item?.mp3_url
              "
            >
              <div class="audio-item-generate-progress-bar">
                <div
                  class="audio-item-generate-progress-bar-progress"
                  :style="{
                    width: renderData.generateProgressText,
                  }"
                ></div>
              </div>
              <div class="audio-item-generate-progress-text">
                {{ renderData.generateProgressText }}
              </div>
            </div>
            <div
              class="audio-item-decription-box"
              v-if="
                !(
                  [2, 3].includes(props.pitem?.generation_method) &&
                  props.pitem?.is_generated_from_uploaded_file &&
                  !props.item?.stream_key &&
                  !props.item?.mp3_url
                )
              "
            >
              <div class="audio-item-decription line-1 olh">
                <span class="rotate-loading" v-if="props.pitem?.state == 2"> </span>
                {{ getCreateDescription() }}
              </div>
              <div class="audio-item-decription line-2 olh">
                <!-- <span class="audio-item-decription-created-at fn-inline">
                  {{ formatData((props.item?.generate_at ?? 0) * 1000) }}
                  {{ "&nbsp;|&nbsp" }}
                </span> -->
                <!-- <span
                  class="audio-item-decription-duration-loading rotate-loading fn-inline"
                  v-if="renderData.isGenerating"
                >
                </span> -->
                <span class="audio-item-decription-duration fn-inline">
                  {{ props.pitem?.state != 2 ? renderData.durationText : "--:--" }}
                </span>
              </div>
            </div>
          </div>

          <div class="audio-item-wave-time">
            {{ renderData.durationText }}
          </div>
          <div class="audio-item-wave-box flex1 width-0">
            <AudioWavForm
              v-if="
                createRenderType != 'mobile' &&
                (props.item?.wave_list?.length || props.listRenderType != 'createdresult')
              "
              :url="renderData.url"
              :style="{
                '--progressColor': '#94ADFF',
                '--progressTrasform': 'scaleY(1.4)',
              }"
              :isPlaying="renderData.isplay"
              :waveformData="props.item?.wave_list"
              :showChangeProgress="true"
              :progress="renderData.progress / 100"
              @changeProgress="changeProgress"
              :hideChangeProgress="true"
            ></AudioWavForm>
          </div>
          <div class="audio-item-info-op-box flex">
            <div class="audio-item-ops-btns flex">
              <div
                class="audio-item-more-box audio-item-ico-btn pointer flex-center"
                v-if="
                  reRenderMorePop &&
                  props.isSelf &&
                  !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                  (!ModuleOpenStateControl.editor.regionEditing ||
                    (ModuleOpenStateControl.editor.regionEditing && props.duration > 30) ||
                    ModuleOpenStateControl.editor.extendEditing ||
                    (!ModuleOpenStateControl.editor.extendEditing && props.duration > 15) ||
                    ModuleOpenStateControl.editor.lyricsTranslate ||
                    ModuleOpenStateControl.editor.coverVoice ||
                    (ModuleOpenStateControl.editor.trimEditing && props.duration > 30))
                "
              >
                <el-popover
                  ref="refPopover"
                  popper-class="audio-item-more-popover"
                  :placement="renderData.position"
                  :disabled="props.pitem?.state == 2 || createRenderType == 'mobile'"
                >
                  <template #reference>
                    <div
                      class="audio-item-more-btn audio-item-more-btn-edit flex-center audio-item-ico-btn ico-btn"
                      :class="{
                        disabled: props.pitem?.state == 2,
                      }"
                      @mouseover.native="onMoreMouseOver"
                      @click="
                        () => {
                          doShowMore('edit');
                        }
                      "
                    >
                      <i class="block"></i>
                      <span>{{ $$t("editor.edit") }}</span>
                    </div>
                  </template>
                  <div class="audio-item-more-list-box">
                    <div class="audio-item-more-list">
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(
                            props.isGenerating ||
                            isDisableByAudit() ||
                            props.pitem?.state == 2 ||
                            [7].includes(props.pitem?.generation_method)
                          ) &&
                          (!ModuleOpenStateControl.editor.regionEditing ||
                            (ModuleOpenStateControl.editor.regionEditing &&
                              renderData.duration > 30))
                        "
                        @click="doRegenerate"
                      >
                        <div
                          class="audio-item-more-list-item-regenerate audio-item-more-list-item-main"
                        >
                          <span class="olh">
                            {{
                              ModuleOpenStateControl.editor.regionEditing
                                ? $$t("editor.region_editing")
                                : $$t("create.regenerate")
                            }}
                          </span>

                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                          <label
                            class="beta_plan tc"
                            v-if="ModuleOpenStateControl.editor.regionEditingBeta"
                          >
                            {{ $$t("create.beta") }}
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'region_editing');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(
                            props.isGenerating ||
                            isDisableByAudit() ||
                            props.pitem?.state == 2 ||
                            [7].includes(props.pitem?.generation_method)
                          ) &&
                          (ModuleOpenStateControl.editor.extendEditing ||
                            (!ModuleOpenStateControl.editor.extendEditing &&
                              renderData.duration > 15))
                        "
                        @click="
                          () => {
                            doExtend();
                          }
                        "
                      >
                        <div
                          class="audio-item-more-list-item-extend audio-item-more-list-item-main"
                        >
                          <span class="olh">
                            {{
                              ModuleOpenStateControl.editor.extendEditing
                                ? $$t("editor.extend_editing")
                                : $$t("create.extend")
                            }}
                          </span>
                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                          <label
                            class="beta_plan tc"
                            v-if="ModuleOpenStateControl.editor.extendEditingBeta"
                          >
                            {{ $$t("create.beta") }}
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'extend');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>

                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                          ModuleOpenStateControl.editor.trimEditing &&
                          renderData.duration > 30
                        "
                        @click="doTrimEditing"
                      >
                        <div class="audio-item-more-list-item-trim audio-item-more-list-item-main">
                          <span class="olh">
                            {{ $$t("editor.trim") }}
                          </span>
                          <label
                            class="beta_plan tc"
                            v-if="ModuleOpenStateControl.editor.trimEditingBeta"
                          >
                            {{ $$t("create.beta") }}
                          </label>
                        </div>
                      </div>

                      <div
                        class="audio-item-more-list-item"
                        @click="doLyricsTranslate"
                        v-if="
                          !(
                            props.isGenerating ||
                            isDisableByAudit() ||
                            props.pitem?.state == 2 ||
                            [7].includes(props.pitem?.generation_method)
                          ) && ModuleOpenStateControl.editor.lyricsTranslate
                        "
                      >
                        <div
                          class="audio-item-more-list-item-extend audio-item-more-list-item-main"
                        >
                          <span class="olh">
                            {{ $$t("editor.lyrics_translate") }}
                          </span>
                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                          <label
                            class="beta_plan tc"
                            v-if="ModuleOpenStateControl.editor.lyricsTranslateBeta"
                          >
                            {{ $$t("create.beta") }}
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'lyrics_translate');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(
                            props.isGenerating ||
                            isDisableByAudit() ||
                            props.pitem?.state == 2 ||
                            [7].includes(props.pitem?.generation_method)
                          ) && ModuleOpenStateControl.editor.coverVoice
                        "
                        @click="doCoverVoice"
                      >
                        <div
                          class="audio-item-more-list-item-extend audio-item-more-list-item-main"
                        >
                          <span class="olh">
                            {{ $$t("editor.cover_voice") }}
                          </span>
                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                          <label
                            class="beta_plan tc"
                            v-if="ModuleOpenStateControl.editor.coverVoiceBeta"
                          >
                            {{ $$t("create.beta") }}
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'cover_voice');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <Bubble
                position="top"
                :disabled="
                  props.pitem?.generation_method == 6 ||
                  (props.pitem?.state == 2 && !props.item?.stream_key) ||
                  isDisableByAudit()
                "
                :content="$$t('create.copy_song_link')"
                v-model:successContent="renderData.shareSuccessText"
              >
                <div
                  class="audio-item-share audio-item-ico-btn audio-item-ico-btn-share ico-btn pointer flex-center"
                  :class="{
                    disabled:
                      isDisableByAudit() ||
                      (props.pitem?.state == 2 && !props.item.stream_key) ||
                      props.pitem?.generation_method == 6 ||
                      (props.pitem?.generation_method == 9 &&
                        props.pitem?.is_generated_from_uploaded_file),
                  }"
                  @click="doShare"
                >
                  <i class="block"></i>
                </div>
              </Bubble>
              <div
                class="audio-item-more-box audio-item-ico-btn pointer flex-center"
                v-if="
                  reRenderMorePop &&
                  props.isSelf &&
                  !(isDisableByAudit() || props.isGenerating || props.pitem.state == 2)
                "
              >
                <el-popover
                  ref="refPopover"
                  popper-class="audio-item-more-popover"
                  :placement="renderData.position"
                  :disabled="props.pitem?.state == 2 || createRenderType == 'mobile'"
                >
                  <template #reference>
                    <div
                      class="audio-item-more-btn audio-item-more-btn-download flex-center audio-item-ico-btn ico-btn"
                      :class="{
                        disabled: props.pitem?.state == 2,
                      }"
                      @mouseover.native="onMoreMouseOver"
                      @click="
                        () => {
                          doShowMore('download');
                        }
                      "
                    >
                      <i class="block"></i>
                    </div>
                  </template>

                  <div class="audio-item-more-list-box">
                    <div class="audio-item-more-list">
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(
                            props.pitem?.is_generated_from_uploaded_file ||
                            [2, 3, 5, 6, 8, 9].includes(props.pitem?.generation_method)
                          ) &&
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2)
                        "
                        @click="doDownloadVideo"
                      >
                        <div class="audio-item-more-list-item-main">
                          <img src="@/assets/img/audio-video-m-ico.png" />
                          <span class="olh">
                            {{ $$t("create.download_video") }}
                          </span>

                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'download_video');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2)
                        "
                        @click="doDownloadWAVAndStem"
                      >
                        <div class="audio-item-more-list-item-main">
                          <img src="@/assets/img/audio-download-ws-m-ico.png" />
                          <span class="olh">
                            {{ $$t("create.download_wav_mp3") }}
                          </span>

                          <label
                            class="vip_plan"
                            v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                          >
                            <em>{{ $$t("create.pro_plan") }}</em>
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'download_instrumental_stem');
                            }
                          "
                          v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                          !props.pitem?.is_generated_from_uploaded_file
                        "
                        @click="doDownloadCopyright"
                      >
                        <div class="audio-item-more-list-item-main">
                          <img src="@/assets/img/audio-download-oc-m-ico.png" />
                          <span class="olh">
                            {{ $$t("create.download_copyright") }}
                          </span>
                          <label
                            class="vip_plan_basic"
                            v-if="!userDataStore.userInfo?.user?.is_vip"
                          >
                            <em>{{ $$t("create.basic_plan") }}</em>
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'download_license');
                            }
                          "
                          v-if="!userDataStore.userInfo?.user?.is_vip"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        @click="doDownloadMp3"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                          props.renderType != 'createdetail'
                        "
                      >
                        <div class="audio-item-more-list-item-main">
                          <img src="@/assets/img/download-audio-ico.png" />
                          <span class="olh">
                            {{
                              props.pitem?.generation_method == 2
                                ? $$t("editor.download_whole_mp3")
                                : $$t("create.download_mp3")
                            }}
                          </span>

                          <label
                            class="vip_plan_basic"
                            v-if="!userDataStore.userInfo?.user?.is_vip"
                          >
                            <em>{{ $$t("create.basic_plan") }}</em>
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'download_mp3');
                            }
                          "
                          v-if="!userDataStore.userInfo?.user?.is_vip"
                        ></div>
                      </div>
                      <div
                        class="audio-item-more-list-item"
                        @click="doDownloadExtendMp3"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                          ModuleOpenStateControl.editor.extendEditing &&
                          props.pitem?.generation_method == 2
                        "
                      >
                        <div class="audio-item-more-list-item-main">
                          <img src="@/assets/img/download-extend-audio-ico.svg" />
                          <span class="olh">
                            {{ $$t("editor.download_extend_mp3") }}
                          </span>

                          <label
                            class="vip_plan_basic"
                            v-if="!userDataStore.userInfo?.user?.is_vip"
                          >
                            <em>{{ $$t("create.basic_plan") }}</em>
                          </label>
                        </div>

                        <div
                          class="vip_plan-mask"
                          @click.stop="
                            (e) => {
                              goSubscribe(e, 'download_extend_mp3');
                            }
                          "
                          v-if="!userDataStore.userInfo?.user?.is_vip"
                        ></div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <Bubble
                position="top"
                :disabled="
                  props.pitem?.generation_method == 6 ||
                  (props.pitem?.state == 2 && !props.item?.stream_key) ||
                  isDisableByAudit()
                "
                :content="
                  [1, 3, 4].includes(props.item?.publish_state)
                    ? $$t('create.published')
                    : $$t('create.song_apply_to_publish')
                "
              >
                <div
                  class="audio-item-ico-btn ico-btn pointer flex-center"
                  :class="{
                    'audio-item-publish': ![1, 3, 4].includes(props.item?.publish_state),
                    'audio-item-published': [1, 3, 4].includes(props.item?.publish_state),
                    disabled:
                      props.pitem?.is_generated_from_uploaded_file ||
                      props.isGenerating ||
                      isDisableByAudit() ||
                      props.pitem?.state == 2,
                  }"
                  @click="
                    () => {
                      doAddShoping([1, 3, 4].includes(props.item?.publish_state) ? 1 : 0);
                    }
                  "
                >
                  <i class="block"></i>
                </div>
              </Bubble>
              <!-- <div
                class="audio-item-btn audio-item-btn-publish audio-item-btn1"
                :class="{
                  disabled:
                    props.pitem?.is_generated_from_uploaded_file ||
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem?.state == 2,
                }"
              >
                <Button
                  :disabled="
                    props.pitem?.is_generated_from_uploaded_file ||
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem?.state == 2
                  "
                  @click="
                    () => {
                      doAddShoping(
                        [1, 3, 4].includes(props.item?.publish_state) ? 1 : 0
                      );
                    }
                  "
                  :renderStyle="{
                    '--padding': '0 15px',
                    '--width': 'max-content',
                    '--height': '32px',
                    '--borderRadius': '50px',
                    '--background': 'rgba(255, 255, 255, 0.1)',
                    '--fontColor': '#fff',
                    '--fontSize': '14px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                    '--fontColor': '#fff',
                  }"
                  >{{
                    [1, 3, 4].includes(props.item?.publish_state)
                      ? $$t("create.published")
                      : $$t("create.song_apply_to_publish")
                  }}</Button
                >
              </div> -->
              <Bubble
                class="item"
                effect="dark"
                v-if="props.listRenderType != 'dislikemysong' && createRenderType != 'mobile'"
                :disabled="
                  (props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit()
                "
                :content="
                  props.item?.is_liked == 1 && props.item?.is_disliked != 1
                    ? $$t('editor.unlike')
                    : $$t('editor.like')
                "
                placement="top"
              >
                <div
                  class="audio-item-like-status audio-item-ico-btn ico-btn pointer flex-center"
                  :class="{
                    disabled:
                      (props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit(),
                  }"
                  @click="
                    () => {
                      doLike();
                    }
                  "
                >
                  <i
                    class="block"
                    :class="{
                      'like-true': props.item?.is_liked == 1 && props.item?.is_disliked != 1,
                    }"
                  ></i>
                </div>
              </Bubble>
              <Bubble
                class="item"
                effect="dark"
                v-if="props.listRenderType != 'likemysong' && createRenderType != 'mobile'"
                :disabled="
                  (props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit()
                "
                :content="
                  props.item?.is_disliked == 1 && props.item?.is_liked != 1
                    ? $$t('editor.undislike')
                    : $$t('editor.dislike')
                "
                placement="top"
              >
                <div
                  class="audio-item-unlike-status audio-item-ico-btn ico-btn pointer flex-center"
                  :class="{
                    disabled:
                      (props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit(),
                  }"
                  @click="
                    () => {
                      doDislike();
                    }
                  "
                >
                  <i
                    class="block"
                    :class="{
                      'unlike-true': props.item?.is_disliked == 1 && props.item?.is_liked != 1,
                    }"
                  ></i>
                </div>
              </Bubble>

              <Bubble
                position="top"
                v-if="createRenderType != 'mobile'"
                :disabled="
                  props.isGenerating ||
                  props.pitem?.state == 2 ||
                  !ModuleOpenStateControl.speControl.feedback
                "
                :content="$$t('editor.feedback')"
              >
                <div
                  class="audio-item-feedback audio-item-ico-btn audio-item-ico-btn-feedback ico-btn pointer flex-center"
                  :class="{
                    disabled:
                      props.isGenerating ||
                      props.pitem?.state == 2 ||
                      !ModuleOpenStateControl.speControl.feedback,
                  }"
                  @click="doFreeback"
                >
                  <i class="block"></i>
                </div>
              </Bubble>
              <div
                class="audio-item-btn audio-item-btn1"
                v-if="ModuleOpenStateControl.create.release"
              >
                <Button
                  :disabled="props.isGenerating || isDisableByAudit() || props.pitem?.state == 2"
                  @click="doRelease"
                  :renderStyle="{
                    '--padding': '0 15px',
                    '--width': '94px',
                    '--height': '32px',
                    '--borderRadius': '50px',
                    '--background': 'rgba(255, 255, 255, 0.1)',
                    '--fontColor': '#fff',
                    '--fontSize': '14px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                    '--fontColor': '#fff',
                  }"
                  >{{
                    props.item?.release_info?.release_state == 4
                      ? $$t("create.released")
                      : !props.item?.release_info?.release_state
                        ? $$t("create.release")
                        : $$t("create.releasing")
                  }}
                  <span v-if="props.item?.release_info?.unread" class="unread"></span>
                </Button>
              </div>
              <div
                class="audio-item-more-box audio-item-ico-btn pointer flex-center"
                v-if="reRenderMorePop"
              >
                <el-popover
                  ref="refPopover"
                  popper-class="audio-item-more-popover"
                  :placement="renderData.position"
                  :disabled="props.pitem?.state == 2 || createRenderType == 'mobile'"
                >
                  <template #reference>
                    <div
                      class="audio-item-more-btn flex-center audio-item-ico-btn ico-btn"
                      :class="{
                        disabled: props.pitem?.state == 2,
                      }"
                      @mouseover.native="onMoreMouseOver"
                      @click="
                        () => {
                          doShowMore('more');
                        }
                      "
                    >
                      <i class="block"></i>
                    </div>
                  </template>

                  <div class="audio-item-more-list-box">
                    <div class="audio-item-more-list">
                      <div
                        class="audio-item-more-list-item"
                        v-if="
                          ModuleOpenStateControl.create.generateStepProgressMenu &&
                          props.pitem?.thinking_process_url
                        "
                        @click="doShowGenerateStepProgress"
                      >
                        <div
                          class="audio-item-more-list-item-extend audio-item-more-list-item-main flex"
                        >
                          <img src="@/assets/img/generate_step_progress.svg" />
                          <span class="olh">
                            {{ $$t("editor.generate_step_progress") }}
                          </span>
                        </div>
                      </div>
                      <!-- <div
                      class="audio-item-more-list-item"
                      v-if="globalConfig.appname == chinaAppName"
                    >
                      <div
                        class="audio-item-more-list-item-sale-box"
                        v-if="!props.item?.state"
                        :class="{
                          disabled:
                            props.pitem?.is_generated_from_uploaded_file ||
                            isDisableByAudit(),
                        }"
                        @click="doAddShoping"
                      >
                        {{
                          globalConfig.appname == chinaAppName
                            ? $$t("create.song_apply_to_sell")
                            : $$t("create.song_apply_to_publish")
                        }}
                      </div>
                      <div
                        class="audio-item-more-list-item-sale-box disabled"
                        v-if="props.item?.state == 1"
                      >
                        {{ $$t("create.song_sale_under_review") }}
                      </div> 
                      <div
                        class="audio-item-more-list-item-sale-box disabled"
                        v-if="props.item?.state == 2"
                      >
                        {{ $$t("create.song_on_sale") }}
                      </div>
                      <div
                        class="audio-item-more-list-item-sale-box disabled"
                        v-if="props.item?.state == 3"
                      >
                        {{ $$t("create.song_suspend_sale") }}
                      </div>
                      <div
                        class="audio-item-more-list-item-sale-box disabled"
                        v-if="props.item?.state == 4"
                      >
                        {{ $$t("create.song_sold_out") }}
                      </div>
                      <div
                        class="audio-item-more-list-item-sale-box disabled"
                        v-if="props.item?.state == 5"
                      >
                        {{ $$t("create.song_sale_review_failed") }}
                        <Bubble
                          class="item"
                          effect="dark"
                          :content="
                            $$t('create.song_sale_review_failed_reason')
                          "
                          placement="left"
                        >
                          <i class="fn-inline tc info-ico"></i>
                        </Bubble>
                      </div>
                    </div>
                    -->

                      <div
                        class="audio-item-more-list-item flex"
                        @click="doRestore"
                        v-if="
                          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2)
                        "
                      >
                        <img src="@/assets/img/audio-restore-m-ico.png" />
                        <span>
                          {{ $$t("create.restore") }}
                        </span>
                      </div>
                      <div
                        class="audio-item-more-list-item flex"
                        v-if="
                          !(
                            props.isGenerating ||
                            [1, 3, 4].includes(props.item.publish_state) ||
                            isDisableByAudit() ||
                            props.pitem?.state == 2
                          )
                        "
                        @click="doEditSongTitle"
                      >
                        <img src="@/assets/img/audio-edit-m-ico.png" />
                        <span class="olh"> {{ $$t("create.edit_feed_song_info") }}</span>
                      </div>
                      <!-- <div
                        v-if="
                          !(props.isGenerating || props.pitem?.state == 2) &&
                          ModuleOpenStateControl.speControl.feedback
                        "
                        class="audio-item-more-list-item"
                        @click="doFreeback"
                      >
                        <img src="@/assets/img/feedback-ico-white.png" />
                        <span class="olh">{{ $$t("editor.feedback") }}</span>
                      </div> -->
                      <div
                        v-if="!(props.isGenerating || props.pitem?.state == 2) && isAllowedDelete()"
                        class="audio-item-more-list-item flex"
                        @click="doDelete"
                      >
                        <img src="@/assets/img/audio-delete-m-ico.png" />
                        <span class="olh">{{ $$t("create.delete") }}</span>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
            <div
              class="audio-item-ops-btn-more flex-center"
              :class="{
                disabled:
                  (props.pitem?.state == 2 && !props.item?.stream_key) ||
                  (globalConfig.appname == chinaAppName && props.pitem?.state == 2),
              }"
              @click="doShowMore"
            >
              <i class="block"></i>
            </div>
          </div>
        </div>
      </div>
    </AudioPlayer>
  </div>
  <div v-if="props.renderType == 'createdetail'" class="audio-item-createdetail-btns-box">
    <AudioItemDetailBtns
      :duration="renderData.duration"
      :pitem="props.pitem"
      :item="props.item"
      :playLoading="playLoading"
      :isGenerating="renderData.isGenerating"
      :isSelf="props.isSelf"
      @regenerate="doRegenerate"
      @extend="doExtend"
      @trimEditing="doTrimEditing"
      @lyricsTranslate="doLyricsTranslate"
      @coverVoice="doCoverVoice"
      @share="doShare"
      @like="doLike"
      @dislike="doDislike"
      @more="
        (pitem, item, type) => {
          doShowMore(type);
        }
      "
      @downloadMp3="doDownloadMp3"
      @downloadExtendMp3="doDownloadExtendMp3"
      @doDownloadVideo="doDownloadVideo"
      @downloadCopyright="doDownloadCopyright"
      @downloadWAVAndStem="doDownloadWAVAndStem"
      @playVideo="doPlayVideo"
      @restore="doRestore"
      @delete="doDelete"
      @addShoping="doAddShoping"
      @onSureToPublish="onSureToPublish"
      @onEditSongTitle="doEditSongTitle"
      @report="doReport"
      @handleSimilar="doHandleSimilar"
      @feedback="doFreeback"
      @showGenerateStepProgress="doShowGenerateStepProgress"
    ></AudioItemDetailBtns>
  </div>
  <ExtendSongDialog
    v-model:visible="renderData.extendSongDialogVisible"
    v-if="renderData.extendSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
    @reGenerate="doExtendDoneReGenerate"
  ></ExtendSongDialog>
  <EditSongDialog
    v-model:visible="renderData.editSongDialogVisible"
    v-if="renderData.editSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
    @reGenerate="doEditSongDoneReGenerate"
  ></EditSongDialog>
  <!-- <GoSellSongDialog
    :pitem="props.pitem"
    :item="props.item"
    v-model:visible="renderData.goSellSongDialogVisible"
    v-if="
      renderData.goSellSongDialogVisible && globalConfig.appname == chinaAppName
    "
    @complete="onSureToSell"
  ></GoSellSongDialog> -->
  <DownloadCopyright
    :pitem="props.pitem"
    :item="props.item"
    :orderId="renderData.downloadCopyrightOrderId"
    v-model:visible="renderData.downloadCopyrightDialogVisible"
    v-if="renderData.downloadCopyrightDialogVisible"
    @complete="onDownloadCopyright"
  ></DownloadCopyright>
  <DownloadSong
    :pitem="props.pitem"
    :item="props.item"
    v-model:visible="renderData.downloadSongAllDataDialogVisible"
    v-if="renderData.downloadSongAllDataDialogVisible"
    @download="onDownloadSongAllData"
  ></DownloadSong>
  <!-- <QrCodePayDialog
    :dialogTitle="$$t('create.buy_song_wav_stem')"
    :totalPrice="99"
    :orderId="renderData.downloadSongAllDataOrderId"
    :qrCode="renderData.songPayQrCode"
    v-model:visible="renderData.buySongPayDialogVisible"
    v-if="renderData.buySongPayDialogVisible"
    :paySuccess="onBuySongPaySuccess"
    :payFail="onBuySongFail"
  ></QrCodePayDialog> -->
  <AudioItemOpDialog
    v-model:visible="renderData.moreDialogVisible"
    v-if="renderData.moreDialogVisible"
    :type="renderData.moreDialogType"
    :renderType="props.renderType"
    :duration="renderData.duration"
    :listRenderType="props.listRenderType"
    :pitem="props.pitem"
    :item="props.item"
    :isGenerating="renderData.isGenerating"
    :isSelf="props.isSelf"
    @restore="doRestore"
    @regenerate="doRegenerate"
    @extend="doExtend"
    @trimEditing="doTrimEditing"
    @lyricsTranslate="doLyricsTranslate"
    @coverVoice="doCoverVoice"
    @share="doShare"
    @like="doLike"
    @dislike="doDislike"
    @download="doDownload"
    @doDownloadVideo="doDownloadVideo"
    @downloadMp3="doDownloadMp3"
    @downloadExtendMp3="doDownloadExtendMp3"
    @downloadCopyright="doDownloadCopyright"
    @downloadWAVAndStem="doDownloadWAVAndStem"
    @addShoping="doAddShoping"
    @release="doRelease"
    @soldOut="doSoldOut"
    @delete="doDelete"
    @editSongTitle="doEditSongTitle"
    @openSaleReviewFailedReason="doOpenSaleReviewFailedReason"
    @report="doReport"
    @feedback="doFreeback"
    @showGenerateStepProgress="doShowGenerateStepProgress"
  ></AudioItemOpDialog>
  <GoToPublish
    v-model:visible="renderData.goSellSongDialogVisible"
    v-if="renderData.goSellSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
    @complete="onSureToPublish"
  ></GoToPublish>
  <EditSongBasicInfoDialog
    v-model:visible="renderData.editSongInfoVisible"
    v-if="renderData.editSongInfoVisible"
    :pitem="props.pitem"
    :item="props.item"
    @complete="onSureToSaveSongInfo"
  ></EditSongBasicInfoDialog>
  <ExtendEditingDialog
    v-model:visible="renderData.extendEditSongDialogVisible"
    v-if="renderData.extendEditSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  ></ExtendEditingDialog>
  <RegionEditingDialog
    v-model:visible="renderData.regionEditSongDialogVisible"
    v-if="renderData.regionEditSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  ></RegionEditingDialog>
  <TrackStemDialog
    v-model:visible="renderData.trackStemSongDialogVisible"
    v-if="renderData.trackStemSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  >
  </TrackStemDialog>
  <CoverVoiceDialog
    v-model:visible="renderData.coverVoiceSongDialogVisible"
    v-if="renderData.coverVoiceSongDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  >
  </CoverVoiceDialog>

  <LyricsTranslateDialog
    v-model:visible="renderData.lyricsTranslateDialogVisible"
    v-if="renderData.lyricsTranslateDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  >
  </LyricsTranslateDialog>
  <TrimEditingDialog
    v-model:visible="renderData.trimEditingDialogVisible"
    v-if="renderData.trimEditingDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  >
  </TrimEditingDialog>
  <GenerateStepDialog
    v-if="renderData.generateStepDialogVisible"
    v-model:visible="renderData.generateStepDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
  ></GenerateStepDialog>
  <ReportDialog
    v-if="renderData.reportDialogVisible"
    v-model:visible="renderData.reportDialogVisible"
    :pitem="props.pitem"
    :data="props.item"
    :reportType="4"
  ></ReportDialog>

  <FreebackDialog
    v-if="renderData.feedbackDialogVisible"
    v-model:visible="renderData.feedbackDialogVisible"
    :pitem="props.pitem"
    :item="props.item"
    :hideType="true"
    :type="1"
  ></FreebackDialog>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

const MIN_ITEM_WIDTH = 400;

import defaultCover from "@/assets/img/default-cover-3x.png";
import LoaderWave from "@/components/animation/LoaderWave.vue";
import EditSongBasicInfoDialog from "@/page/create/feedSongOp/editSongBasicInfo.vue";

import ExtendSongDialog from "@/page/create/editSong/extendSong.vue";
import EditSongDialog from "@/page/create/editSong/regenerateSong.vue";
import GoSellSongDialog from "@/page/create/feedList/goToSell.vue";
import DownloadSong from "@/page/create/feedList/downloadSong.vue";
import DownloadCopyright from "@/page/create/feedList/downloadCopyright.vue";
import GoToPublish from "@/page/create/feedSongOp/goToPublish.vue";
import RegionEditingDialog from "@/page/editor/regionEditing/regionEditingDialog.vue";
import ExtendEditingDialog from "@/page/editor/extendEditing/extendEditingDialog.vue";
import CoverVoiceDialog from "@/page/editor/coverVoice/coverVoiceDialog.vue";
import TrackStemDialog from "@/page/editor/trackStem/trackStemDialog.vue";
import LyricsTranslateDialog from "@/page/editor/lyricsTranslate/lyricsTranslateDialog.vue";
import TrimEditingDialog from "@/page/editor/trimEditing/trimEditingDialog.vue";
import GenerateStepDialog from "@/page/create/generateStep/generateStepDialog.vue";
import ReportDialog from "@/components/report/reportDialog.vue";
import FreebackDialog from "@/components/feedbackDialog/feedbackDialog.vue";
// import QrCodePayDialog from "@/components/wxPayDialog/wxPayDialog.vue";
import AudioItemDetailBtns from "@/page/create/feedList/audioItemDetailBtns.vue";
import AudioWavForm from "@/components/media/audioPlayer/AudioWavForm.vue";
import LazyLoadImg from "@/components/media/lazyLoad/LazyLoadImg.vue";

import Button from "@/components/basic/button/Button.vue";
import { useRouter, useRoute } from "vue-router";
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import Bubble from "@/components/bubble/bubble.vue";
import AudioItemOpDialog from "./audioItemOpDialog.vue";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";

import tools from "@/utils/tools.js";
import mediaUtil from "@/components/media/utils/utils.js";
import { formatDateTime, formatDate } from "@/utils/dateTime.js";
import message from "@/components/functionCallComponent/message.jsx";
import useUserDataStore from "@/store/userDataStore";
const userDataStore = useUserDataStore();
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
import feedListApi from "@/api/api/feedListApi.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useGlobalUserStateStore from "@/store/globalUserStateStore.js";

const globalUserStateStore = useGlobalUserStateStore();

import constTags from "@/config/const.js";

import { payOrder, checkSongOrder } from "@/api/api/apiCommon.js";
import { checkSongReleaseStatus, releaseMessageReadStatusReport } from "@/api/api/apiStore.js";
const feedListDataStore = useFeedListStore();
const globalPlayDataStore = useGlobalPlayDataStore();

import { handlePayMoney } from "@/utils/pay.js";
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const formatData = (timestamp) => {
  return formatDate(timestamp, "YYYY-MM-DD hh:mm");
};

// 0-默认， 1-在售申请，2-在售中，3-停止出售，4-独家已售, 5-审核不通过',
const stateData = {
  stateMap: {
    0: "",
    1: "Sale under review",
    2: "On sale",
    3: "Suspend sale",
    4: "Sold out",
    5: "Sale review failed",
  },
};

const editTypeMap = {
  // 1 song 2-延长  3-编辑  5 翻唱 6 分轨, 7-bgm, 8-翻译
  // 1: $$t("editor.song"),
  2: $$t("editor.extend_editing"),
  3: $$t("editor.region_editing"),
  5: $$t("editor.cover_voice"),
  6: $$t("editor.track_stem"),
  // 7: $$t("editor.bgm"),
  8: $$t("editor.lyrics_translate"),
  // 9: $$t("editor.trim"),
};
const props = defineProps({
  renderType: {
    type: String,
    default: "create", //"", //create createdetail // store
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult
  },
  isSelf: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits([
  "restore",
  "regenerate",
  "extend",
  "regionEditing",
  "extendEditing",
  "from",
  "more",
  "like",
  "dislike",
  "delete",
  "download",
  "addShoping",
  "soldOut",
  "editSongTitle",
  "goDetail",
  "share",
  "downloadMp3",
  "downloadExtendMp3",
  "doPlayVideo",
  "downloadCopyright",
  "downloadWAVAndStem",
  "togglePlay",
  "onSureToPublish",
  "onSureToSaveSongInfo",
  "onSureCancelPublish",
  "handleSimilar",
]);

const playLoading = ref(false);
const refMoreListBox = ref(null);
const refExtendSong = ref(null);
const refPlayer = ref(null);
const refInput = ref(null);
const refPopover = ref(null);
const reRenderMorePop = ref(true);

const getEditorType = (item) => {
  if (item.is_trimmed) {
    return $$t("editor.trim");
  }
  return editTypeMap[item.generation_method];
};

const getAudioUrl = () => {
  const appContext = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext;
  if (
    (props.item?.stream_key &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
        getPipeReadableFlowUrl(props.item?.stream_key) &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.players[
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl
      ]?.isPlaying) ||
    !props.item?.mp3_url
  ) {
    return getPipeReadableFlowUrl(props.item?.stream_key);
  } else {
    return getObjectStorageFullUrl(props.item?.mp3_url);
  }
};
const renderData = reactive({
  itemWidth: 1000,
  url: getAudioUrl(),
  duration: (props.item?.duration_milliseconds ?? 0) / 1000,
  durationText: "00:00",
  isplay: false,
  buffer: false,
  progress: 0,
  title: props.item?.title,
  isEditTitle: false,
  shareSuccessText: "",
  isMoreVisible: false,
  position: "left",
  isCurPlay: false,
  moreDialogType: "",
  moreDialogVisible: false,
  extendSongDialogVisible: false,
  editSongDialogVisible: false,
  goSellSongDialogVisible: false,
  downloadSongAllDataDialogVisible: false,
  downloadCopyrightDialogVisible: false,
  buySongPayDialogVisible: false,
  editSongInfoVisible: false,
  downloadCopyrightOrderId: null,

  extendEditSongDialogVisible: false,
  regionEditSongDialogVisible: false,

  lyricsTranslateDialogVisible: false,
  trimEditingDialogVisible: false,
  generateStepDialogVisible: false,
  reportDialogVisible: false,
  feedbackDialogVisible: false,

  downloadSongAllDataOrderId: null,
  songPayQrCode: false,

  hasPlayed: props.item?.is_played ?? false,
  isGenerating:
    props.renderType == "createdetail"
      ? !/\.[0-9A-Za-z]{1,}$/.test(props.item.mp3_url ?? "") && props.item?.stream_key
      : props.pitem?.state == 2 && !!props.item.stream_key,

  generateProgressText: "0%",
  generateProgress: 0,
});

const combineStrings = (str1, str2) => {
  if (!(Array.isArray(str1) && Array.isArray(str2))) return;
  if (str1 && str2) {
    return `${str1.join(" ")} / ${str2.join(" ")}`;
  }
  return str1?.join(" ") || str2?.join(" ");
  // str1 =>genres str2 => moods
  // const genres = constTags.getRenderLabel(str1, constTags.StyleLabelData.map,  $$language());
  // const moods = constTags.getRenderLabel(
  //   str2,
  //   constTags.EmotionalLabelData.map,
  //   $$language()
  // );
  // if (genres?.length && moods?.length) {
  //   return `${genres.join(" ")} | ${moods.join(" ")}`;
  // } else if (genres?.length) {
  //   return genres.join(" ");
  // } else if (moods?.length) {
  //   return moods.join(" ");
  // } else {
  //   return "";
  // }
};

const getCreateDescription = () => {
  const description =
    props.pitem?.state > 2 && props.item?.description?.trim()
      ? props.item?.description
      : props.pitem?.state > 2 && !props.item?.description
        ? combineStrings(props.item?.genres, props.item?.moods)
        : "";

  return createRenderType.value == "mobile" || renderData.itemWidth < MIN_ITEM_WIDTH
    ? (props.pitem?.state != 2 ? renderData.durationText : "--:--") +
        (description ? " / " + description : "")
    : (description ?? "");
};
const isDoEditSong = computed(() => {
  return (
    renderData.extendSongDialogVisible ||
    renderData.editSongDialogVisible ||
    renderData.extendEditSongDialogVisible ||
    renderData.regionEditSongDialogVisible ||
    renderData.trackStemSongDialogVisible ||
    renderData.coverVoiceSongDialogVisible ||
    renderData.lyricsTranslateDialogVisible ||
    renderData.trimEditingDialogVisible
  );
});

const updateRenderProgress = () => {
  if (
    renderData.mouted &&
    props.pitem?.is_generated_from_uploaded_file &&
    [2, 3].includes(props.pitem?.generation_method) &&
    !props.item.stream_key &&
    !props.item.mp3_url &&
    props.pitem?.generate_at &&
    props.pitem?.estimate_over_at
  ) {
    requestAnimationFrame(() => {
      const now = Date.now();
      const start = props.pitem.generate_at * 1000;
      const end = props.pitem.estimate_over_at * 1000;
      const duration = end - start;

      const progress = (now - start) / duration;
      const clamped = Math.max(0, Math.min(0.99, progress));

      renderData.generateProgress = clamped;
      renderData.generateProgressText = `${Math.floor(clamped * 100)}%`;
      updateRenderProgress(); // loop again
    });
  }
};

const doHandleSimilar = () => {
  emits("handleSimilar", props.pitem, props.item);
};

const doReport = () => {
  pointerLogClickEvent("report");
  reRenderMore();
  renderData.reportDialogVisible = true;
};

const doFreeback = () => {
  pointerLogClickEvent("feedback");
  reRenderMore();
  renderData.feedbackDialogVisible = true;
};

const doShowMore = (type) => {
  if (createRenderType.value == "mobile") {
    renderData.moreDialogType = type;
    renderData.moreDialogVisible = true;
  }
};
const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4].includes(props.item?.machine_audit_state) ||
    [4].includes(props.item?.publish_state) ||
    props.pitem.state == 12 ||
    (globalConfig.appname == chinaAppName && props.pitem?.state == 2)
  );
};
const isAllowedDelete = () => {
  return true;
};

const calcSetMoreListBoxPosition = () => {
  if (refMoreListBox.value) {
    const { top, height } = refMoreListBox.value.getBoundingClientRect();
    if (top + height / 2 <= document.body.clientHeight / 4) {
      renderData.position = "left-start";
    } else if (top + height / 2 >= (document.body.clientHeight / 4) * 3) {
      renderData.position = "left-end";
    } else {
      renderData.position = "left-start";
    }
  }
};

const onMoreMouseOver = () => {
  if (createRenderType.value != "mobile") {
    calcSetMoreListBoxPosition();
  }
};
const syncDuration = (duration) => {
  renderData.duration = duration;
};

const syncPlayState = (playState) => {
  renderData.isplay = playState;
  if (renderData.isplay) {
    // if (!renderData.hasPlayed && !props.item?.is_played) {
    //   feedListDataStore
    //     .doReportPlayedState(props.pitem, props.item)
    //     .then(() => {
    //       renderData.hasPlayed = true;
    //     });
    // }
    // feedListDataStore.doPlayStateReport(props.pitem,props.item, 1);
    if (props.listRenderType == "createdresult") {
      if (createLayoutStore.createEditMode != "easy") {
        globalUserStateStore.showBasicModeClickedGuidVisible("easy");
      } else if (createLayoutStore.createEditMode != "hard") {
        globalUserStateStore.showBasicModeClickedGuidVisible("hard");
      } else {
      }
    }
  }
};
const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};
const syncProgress = (progress) => {
  renderData.progress = progress;
};

const onCurPlayEnded = () => {
  // feedListDataStore.doPlayStateReport(props.pitem,props.item, 2);
};

const changeProgress = (progress) => {
  refPlayer.value?.changeProgress(progress * 100);
};

const doTogglePlay = () => {
  refPlayer.value.changeOp().then((isPlayed) => {
    // if (isPlayed) {
    //   feedListDataStore.doPlayStateReport(props.pitem,props.item, 1);
    // }
  });
  feedListDataStore.doTogglePlay(props.pitem, props.item, renderData.isplay, props.listRenderType);
};

const getDetailFrom = () => {
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  const route = Router.currentRoute.value;
  let tab_stare = "detail";
  if (route.name.includes("songDetail")) {
    if (route.params?.from || route.query?.from) {
      tab_stare = route.params?.from || route.query?.from;
    }
  } else {
    switch (props.listRenderType) {
      case "createdresult":
        if (route.name == "editor") {
          tab_stare = "mine_audio_edit";
        } else if (route.name == "create" || route.name == "createIndex") {
          tab_stare = "mine_generation_song";
        } else if (route.name == "instrumental" || route.name == "bgm") {
          tab_stare = "mine_generation_bgm";
        } else {
          tab_stare = "mine_generation_song";
        }
        break;
      case "mysong":
        tab_stare = "library_my_song";
        break;
      case "likemysong":
        tab_stare = "library_my_song_liked";
        break;
      case "dislikemysong":
        tab_stare = "library_my_song_disliked";
        break;
      case "publishedmysong":
        tab_stare = "library_my_song_published";
        break;
      case "liked":
        tab_stare = "library_not_my_song_liked";
        break;
      default:
        tab_stare = "mine_generation_song";
        break;
    }
  }
  return tab_stare;
};

const pointerLogClickEvent = (source) => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  const route = Router.currentRoute.value;
  if (route.name.includes("songDetail")) {
    globalProperties?.logClickEvent("song_detail_page_edit", {
      content_id: props.item?.song_id,
      source: source,
      tab_stare: getDetailFrom(),
      is_self: props.isSelf ? 1 : 0,
    });
  } else {
    globalProperties?.logClickEvent("create_songlist_edit", {
      content_id: props.item?.song_id,
      source: source,
      tab_stare: getDetailFrom(),
      is_self: props.isSelf ? 1 : 0,
    });
  }
};

const doGoDetail = () => {
  refPlayer.value.changeOp(true).then((isPlayed) => {});
  reRenderMore();
  // 更新列表，当前歌曲播放
  feedListDataStore.doAddPlayList(props.pitem, props.item, props.listRenderType);
  feedListDataStore.doGoDetail(props.pitem, props.item, getDetailFrom());
};

const doTempToggleGlobalPlay = (newValue) => {
  if (newValue) {
    globalPlayDataStore.tempToggle(true);
  } else {
    globalPlayDataStore.tempToggle(false);
  }
};

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation();
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  if (await userDataStore.checkLoginStatus()) {
    Router?.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};

const getSongAuditState = (opName, showToast = true) => {
  const item = props.item;
  return new Promise((resolve, reject) => {
    if (item.machine_audit_state == 3) {
      resolve();
      return;
    }
    let closeMsg;

    if (showToast) {
      closeMsg = message.loading({
        position: "center",
        content: $$t("create.get_song_state_loading"),
      });
    }
    const reEditorOpNames = ["region_editing", "extend", "lyrics_translate", "cover_voice"];
    feedListApi[
      reEditorOpNames.includes(opName) ? "getSongEditorVipLevelState" : "getSongAuditState"
    ]({
      song_id: props.item?.song_id,
    })
      .then((res) => {
        closeMsg?.clear();
        //2-ing 3- chenggong 4-failed
        // int64 machine_audit_state = 11;
        let machine_audit_state = null;
        if (res.code == 200) {
          resolve();
          machine_audit_state = 3;
        } else {
          if (res.code == 6314) {
            machine_audit_state = 2;
            if (showToast) {
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing"),
              });
            }
            reject("song state auditing");
            // feedListDataStore.updateFeedSongItem({
            //   song_id: props.item?.song_id,
            //   machine_audit_state: machine_audit_state,
            // });
          } else if (res.code == 6335) {
            message.error({
              content: $$t("editor.subscripe_level_not_met"),
              position: "top",
            });
            reject("subscripe level not met");
            // userDataStore.getUserInfo();
          } else if (res.code == 6315) {
            machine_audit_state = 4;
            if (showToast) {
              message.info({
                position: "top",
                content: $$t("create.song_state_auditing_failed_disabled"),
              });
            }
            reject("song state auditing failed");
            feedListDataStore.updateFeedSongItem({
              song_id: props.item?.song_id,
              machine_audit_state: machine_audit_state,
            });
          } else {
            resolve();
            // message.info({
            //   position: "top",
            //   content: $$t("create.get_song_state_failed"),
            // });
          }
        }
      })
      .catch(() => {
        reject("song state auditing failed");
        closeMsg?.clear();
        if (showToast) {
          message.info({
            position: "top",
            content: $$t("create.get_song_state_failed"),
          });
        }
      });
  });
};

const reRenderMore = () => {
  //refPopover.value?.hide();
  reRenderMorePop.value = false;
  nextTick(() => {
    reRenderMorePop.value = true;
  });
};

const doRestore = () => {
  pointerLogClickEvent("restore");
  reRenderMore();
  if (isDisableByAudit()) {
    return;
  }
  getSongAuditState("restore").then(() => {
    feedListDataStore
      .doRestore(props.pitem, props.item)
      .then(() => {
        emits("restore", props.pitem, props.item);
      })
      .catch(() => {});
  });
};

const doRegenerate = () => {
  pointerLogClickEvent("region_editing");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (
    (ModuleOpenStateControl.editor.regionEditing && renderData.duration < 15) ||
    [4].includes(props.item?.state) ||
    isDisableByAudit() ||
    [7].includes(props.pitem?.generation_method)
  ) {
    return;
  }

  getSongAuditState("region_editing").then(() => {
    if (ModuleOpenStateControl.editor.regionEditing) {
      renderData.regionEditSongDialogVisible = true;
    } else {
      renderData.editSongDialogVisible = true;
      globalProperties?.logClickEvent("create_regenerate", {
        content_id: props.item?.song_id,
      });
    }
  });
};

const doExtend = () => {
  pointerLogClickEvent("extend");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (
    props.isGenerating ||
    isDisableByAudit() ||
    props.pitem?.state == 2 ||
    [7].includes(props.pitem?.generation_method)
  ) {
    return;
  }
  if (
    ModuleOpenStateControl.editor.extendMaxDurationLimitModel.includes(props.pitem?.model) ||
    renderData.duration > 4 * 60 + 30
  ) {
    message.info({
      content: $$t("create.extend_max_duration_tip"),
      position: "top",
    });
    return;
  }
  getSongAuditState("extend").then(() => {
    if (ModuleOpenStateControl.editor.extendEditing) {
      renderData.extendEditSongDialogVisible = true;
      globalProperties?.logClickEvent("create_region_editing", {
        content_id: props.item?.song_id,
      });
    } else {
      renderData.extendSongDialogVisible = true;
      globalProperties?.logClickEvent("create_extend", {
        content_id: props.item?.song_id,
      });
    }
  });
};

const doTrimEditing = () => {
  pointerLogClickEvent("trim_editing");
  reRenderMore();
  if (
    !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
    ModuleOpenStateControl.editor.trimEditing &&
    renderData.duration > 30
  ) {
    getSongAuditState("trim_editing").then(() => {
      if (ModuleOpenStateControl.editor.trimEditing) {
        renderData.trimEditingDialogVisible = true;
      }
    });
  }
};

const doLyricsTranslate = () => {
  pointerLogClickEvent("lyrics_translate");
  reRenderMore();
  if (
    [4].includes(props.item?.state) ||
    isDisableByAudit() ||
    [7].includes(props.pitem?.generation_method)
  ) {
    return;
  }
  getSongAuditState("lyrics_translate").then(() => {
    if (ModuleOpenStateControl.editor.lyricsTranslate) {
      renderData.lyricsTranslateDialogVisible = true;
    }
  });
};

const doCoverVoice = () => {
  pointerLogClickEvent("cover_voice");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (
    props.isGenerating ||
    isDisableByAudit() ||
    props.pitem?.state == 2 ||
    [7].includes(props.pitem?.generation_method)
  ) {
    return;
  }
  getSongAuditState("cover_voice").then(() => {
    renderData.coverVoiceSongDialogVisible = true;
    globalProperties?.logClickEvent("create_cover_voice", {
      content_id: props.item?.song_id,
    });
  });
};

const doShowGenerateStepProgress = () => {
  pointerLogClickEvent("creative_process");
  reRenderMore();
  renderData.generateStepDialogVisible = true;
};

const doEditSongDoneReGenerate = ({ startTime }, callback) => {
  reRenderMore();
  feedListDataStore
    .doEditSongDoneReGenerate(props.pitem, props.item, {
      parent_song_id: props.item?.song_id,
      type: 1,
      start_milliseconds: Math.floor(startTime * 1000),
    })
    .then(() => {
      renderData.editSongDialogVisible = false;
      emits("regenerate", props.pitem, props.item);
    })
    .catch((err) => {
      callback(err);
    });
};

const doExtendDoneReGenerate = ({ startTime, lyrics }, callback) => {
  reRenderMore();
  feedListDataStore
    .doExtendDoneReGenerate(props.pitem, props.item, {
      parent_song_id: props.item?.song_id,
      type: 2,
      start_milliseconds: Math.floor(startTime * 1000),
      lyrics,
    })
    .then(() => {
      renderData.extendSongDialogVisible = false;
      emits("extend", props.pitem, props.item);
    })
    .catch((err) => {
      callback(err);
    });
};

const doFrom = () => {
  reRenderMore();
  feedListDataStore.doFrom(props.pitem, props.item);
};
const doDelete = () => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (props.listRenderType == "createdresult") {
    globalProperties?.logCustomEvent("create_delete_song", {
      content_id: props.item?.song_id,
    });
  } else {
    globalProperties?.logCustomEvent("library_delete_song", {
      content_id: props.item?.song_id,
    });
  }

  reRenderMore();
  if (renderData.isGenerating) {
    return;
  }
  feedListDataStore.doDelete(props.pitem, props.item).then(() => {
    emits("delete", props.pitem, props.item);
  });
};

const doLike = () => {
  pointerLogClickEvent(props.item?.is_liked == 1 ? "cancel_like" : "like");
  if ((props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit()) {
    return;
  }
  reRenderMore();
  feedListDataStore
    .doLike(props.pitem, props.item)
    .then((is_like) => {
      // 直接从服务端拿数据，避免prop变更导致的数据不确定性
      emits("like", props.pitem, {
        ...props.item,
        is_liked: is_like,
      });
      if (createRenderType != "mobile") {
        if (is_like == 1) {
          // message.success({
          //   content: $$t("create.like_success"),
          //   position: "top",
          // })
        } else {
          // message.success({
          //   content: $$t("create.unlike_success"),
          //   position: "top",
          // })
        }
      }
    })
    .catch((err) => {
      if (err == 9008) {
        message.info({
          content: $$t("common.tooFrequently"),
          position: "top",
        });
      } else {
        // pm暂定未登录导致的401错误，不进行提示
        // message.error({
        //   content: $$t("common.serverResponding"),
        //   position: "top",
        // });
      }
    });
};

const doDislike = () => {
  pointerLogClickEvent(props.item?.is_disliked == 1 ? "cancel_dislike" : "dislike");
  if ((props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit()) {
    return;
  }
  reRenderMore();
  feedListDataStore
    .doDislike(props.pitem, props.item)
    .then((is_disliked) => {
      // 直接从服务端拿数据，避免prop变更导致的数据不确定性
      emits("dislike", props.pitem, {
        ...props.item,
        is_disliked: is_disliked,
      });
      if (createRenderType != "mobile") {
        if (is_disliked == 1) {
          // message.success({
          //   content: $$t("create.unlike_success"),
          //   position: "top",
          // })
        } else {
          // message.success({
          //   content: $$t("create.unlike_success"),
          //   position: "top",
          // })
        }
      }
    })
    .catch((err) => {
      if (err == 9008) {
        message.info({
          content: $$t("common.tooFrequently"),
          position: "top",
        });
      } else {
        // pm暂定未登录导致的401错误，不进行提示
        // message.error({
        //   content: $$t("common.serverResponding"),
        //   position: "top",
        // });
      }
    });
};

const doDownload = () => {
  reRenderMore();
  if (props.pitem?.state == 2 || isDisableByAudit()) {
    return;
  }
  // renderData.downloadSongAllDataDialogVisible = true;
};

const doPlayVideo = () => {
  emits("doPlayVideo");
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  if (!props.item.video?.video_url) {
    playLoading.value = true;
    getSongAuditState("doPlayVideo").then(() => {
      feedListDataStore
        .doDownloadVideo(props.pitem, props.item)
        .then((res) => {
          playLoading.value = false;
          Router?.push({
            name: "videoDetail",
            query: {
              url: res,
            },
          });
        })
        .catch((err) => {});
    });
  } else {
    Router?.push({
      name: "videoDetail",
      query: {
        url: props.item.video?.video_url,
      },
    });
  }
};

const doDownloadVideo = () => {
  pointerLogClickEvent("download_video");
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  globalProperties?.logClickEvent(
    props.renderType == "createdetail" ? "song_detail_page_downloadvideo" : "create_downloadvideo",
    {}
  );
  reRenderMore();
  if (
    props.pitem?.state == 2 ||
    isDisableByAudit() ||
    [2, 3, 5, 6, 8, 9].includes(props.pitem?.generation_method) ||
    props.pitem?.is_generated_from_uploaded_file
  ) {
    return;
  }
  getSongAuditState("download_video").then(() => {
    feedListDataStore
      .doDownloadVideo(props.pitem, props.item, true)
      .then(() => {})
      .catch((err) => {});
  });
};

const doDownloadMp3 = () => {
  pointerLogClickEvent("download_whole_song_mp3");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (props.pitem?.state == 2 || isDisableByAudit()) {
    return;
  }
  getSongAuditState("download_whole_song_mp3").then(() => {
    feedListDataStore
      .doDownloadMp3(props.pitem, props.item)
      .then(() => {
        emits("downloadMp3", props.pitem, props.item);
      })
      .catch((err) => {});
  });
  globalProperties?.logClickEvent("create_download_mp3", {
    content_id: props.item?.song_id,
  });
};

const doDownloadExtendMp3 = () => {
  pointerLogClickEvent("download_extend_part_mp3");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (props.pitem?.state == 2 || isDisableByAudit()) {
    return;
  }
  getSongAuditState("download_extend_part_mp3").then(() => {
    feedListDataStore
      .doDownloadExtendMp3(props.pitem, props.item)
      .then(() => {
        emits("downloadExtendMp3", props.pitem, props.item);
      })
      .catch((err) => {});
  });
  globalProperties?.logClickEvent("create_download_extend_mp3", {
    content_id: props.item?.song_id,
  });
};

const onDownloadCopyright = (params) => {
  renderData.downloadCopyrightDialogVisible = false;
  feedListDataStore
    .doDownloadCopyright(props.pitem, props.item, params)
    .then(() => {
      emits("downloadCopyright", props.pitem, props.item);
    })
    .catch((err) => {});
  // if (globalConfig.appname == chinaAppName) {
  //   Router?.push({
  //     name: "resultSong",
  //     query: { type: 3, order_id: params.orderId },
  //   });
  // }
};

const doDownloadCopyright = () => {
  pointerLogClickEvent("download_commercial_license");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (
    props.isGenerating ||
    isDisableByAudit() ||
    props.pitem?.state == 2 ||
    props.pitem?.is_generated_from_uploaded_file
  ) {
    return;
  }
  renderData.downloadCopyrightOrderId = null;
  getSongAuditState("download_commercial_license").then(() => {
    let closeMsg = message.loading({
      content: $$t("create.processing_loading"),
    });
    const feedCardGetUsertInfo = feedListApi
      .feedCardGetUsertInfo({
        song_id: props.item?.song_id,
      })
      .then((res) => {
        closeMsg?.clear();
        if (res.code == 200) {
          if (res.data?.download_state == 1 || res.data?.download_state == 3) {
            feedListDataStore.doDownloadCopyright(props.pitem, props.item).then(() => {
              emits("downloadCopyright", props.pitem, props.item);
            });
          } else {
            renderData.downloadCopyrightOrderId = res.data.order_id;
            renderData.downloadCopyrightDialogVisible = true;
          }
        } else {
          if (res.code == 6122) {
            message.warning({
              content: $$t("create.download_copyright_failed_on_sale"),
              position: "top",
            });
          } else {
            message.error({
              content: $$t("common.serverResponding"),
              position: "top",
            });
          }
        }
      })
      .catch((err) => {
        closeMsg?.clear();
        message.error({
          content: $$t("common.serverResponding"),
        });
      });
  });
  globalProperties?.logClickEvent("create_download_copyright", {
    content_id: props.item?.song_id,
  });
};

const payWxMoney = (item) => {
  let closeMsg = message.loading({
    position: "center",
    content: $$t("create.create_order_loading"),
  });
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;

  checkSongOrder({
    song_id: props.item?.song_id,
    t: 4,
    channel: tools.isMobileDevice() ? "wechat_h5" : "wechat_native",
  })
    .then((res) => {
      closeMsg.clear();
      if (res.code == 200) {
        const { wechat_native_url, order_id } = res.data;
        // renderData.songPayQrCode = wechat_native_url;
        renderData.downloadSongAllDataOrderId = order_id;
        renderData.buySongPayDialogVisible = true;
        handlePayMoney(
          {
            totalPrice: 99,
            order_id,
            wechat_native_url,
            discountText: $$t("create.create_order_song_discounts_text"),
          },
          () => {
            onBuySongPaySuccess();
          },
          () => {
            Router?.push({
              name: "resultFail",
            });
          }
        );
      } else {
        message.warning({
          content: $$t("create.create_order_failed"),
          position: "top",
        });
      }
    })
    .catch((err) => {
      closeMsg.clear();
      message.warning({
        content: $$t("create.create_order_failed"),
        position: "top",
      });
    });
};

const doDownloadWAVAndStemRecall = () => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  feedListDataStore
    .doDownloadSongAllData(props.pitem, props.item)
    .then(() => {
      globalProperties?.logClickEvent("create_download_wav&stem", {
        content_id: props.item?.song_id,
      });
    })
    .catch((err) => {});
};

const doDownloadWAVAndStem = () => {
  pointerLogClickEvent("download_instrumental_stem");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (props.pitem?.state == 2 || isDisableByAudit()) {
    return;
  }
  renderData.downloadSongAllDataOrderId = null;
  getSongAuditState("download_instrumental_stem").then(() => {
    // if (
    //   ModuleOpenStateControl.editor.trackStem
    // ) {
    //   renderData.trackStemSongDialogVisible = true;
    //   return;
    // }
    // if (globalConfig.appname != chinaAppName) {
    feedListDataStore
      .doDownloadSongAllData(props.pitem, props.item)
      .then(() => {
        globalProperties?.logClickEvent("create_download_wav&stem", {
          content_id: props.item?.song_id,
        });
      })
      .catch((err) => {});
    //   return;
    // }
    // let closeMsg = message.loading({
    //   content: $$t("create.processing_loading"),
    // });
    // const feedCardGetUsertInfo = feedListApi
    //   .feedCardGetDowloadWAVAndStem({
    //     song_id: props.item?.song_id,
    //   })
    //   .then((res) => {
    //     closeMsg?.clear();
    //     if (res.code == 200) {
    //       if (res.data?.paid_state == 1 || res.data?.paid_state == 3) {
    //         feedListDataStore
    //           .doDownloadSongAllData(props.pitem, props.item)
    //           .then(() => {
    //             globalProperties?.logClickEvent("create_download_wav&stem", {
    //               content_id: props.item?.song_id,
    //             });
    //           })
    //           .catch((err) => {});
    //       } else {
    //         if (globalConfig.appname == chinaAppName) {
    //           payWxMoney(props.item);
    //         } else {
    //           renderData.downloadSongAllDataDialogVisible = true;
    //         }
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     closeMsg?.clear();
    //     message.error({
    //       content: $$t("common.serverResponding"),
    //     });
    //   });
  });
};

const onDownloadSongAllData = (params) => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  renderData.downloadSongAllDataDialogVisible = false;
  feedListDataStore
    .doDownloadSongAllData(props.pitem, props.item)
    .then(() => {
      globalProperties?.logClickEvent("create_download_wav&stem", {
        content_id: props.item?.song_id,
      });
      emits("downloadWAVAndStem", props.pitem, props.item);
    })
    .catch((err) => {});
};

const onBuySongPaySuccess = (params) => {
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  if (globalConfig.appname == chinaAppName) {
    renderData.buySongPayDialogVisible = false;
    Router?.push({
      name: "resultSong",
      query: {
        type: 4,
        order_id: renderData.downloadSongAllDataOrderId,
      },
    });
  } else {
    renderData.downloadSongAllDataDialogVisible = false;
    feedListDataStore
      .doDownloadSongAllData(props.pitem, props.item, {
        order_id: renderData.downloadSongAllDataOrderId,
      })
      .then(() => {
        globalProperties?.logClickEvent("create_download_wav&stem", {
          content_id: props.item?.song_id,
        });
      })
      .catch((err) => {});
  }
};
const onBuySongFail = () => {
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router;
  const onPayFail = () => {
    renderData.buySongPayDialogVisible = false;
    Router?.push({
      name: "resultFail",
      query: {
        order_id: renderData.downloadSongAllDataOrderId,
      },
    });
  };
};
const onSureToPublish = (pitem, item, file, params) => {
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  feedListDataStore.doSureToPublish(pitem, item, file, params).then(() => {
    renderData.goSellSongDialogVisible = false;
    emits("onSureToPublish", pitem, item);
    globalProperties?.logClickEvent("my_song_publish_success", {
      content_id: item?.song_id,
      entity: "my_song_publish_success",
      source:
        props.renderType == "createdetail"
          ? "detail"
          : props.listRenderType != "createdresult"
            ? "library"
            : "create",
    });
  });
};
const onSureToSaveSongInfo = (pitem, item, file, params) => {
  reRenderMore();
  feedListDataStore.doSureToSaveSongInfo(pitem, item, file, params).then(() => {
    renderData.title = params.title;
    renderData.editSongInfoVisible = false;
    emits("onSureToSaveSongInfo", pitem, item);
  });
};
const onSureToSell = (params) => {
  reRenderMore();
  feedListDataStore.doSureSale(props.pitem, props.item, params).then(() => {
    renderData.goSellSongDialogVisible = false;
    emits("onSureToSell", props.pitem, props.item);
  });
};

const doSoldOut = () => {
  reRenderMore();
  feedListDataStore.doSureSoldOut(props.pitem, props.item);
};

const doAddShoping = () => {
  pointerLogClickEvent("publish");
  reRenderMore();
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (
    props.pitem?.is_generated_from_uploaded_file ||
    props.pitem?.state == 2 ||
    isDisableByAudit()
  ) {
    return;
  }
  if ([1, 3, 4].includes(props.item?.publish_state)) {
    feedListDataStore.doSureCancelPublish(props.pitem, props.item).then(() => {
      emits("onSureCancelPublish", props.pitem, props.item);
    });
  } else {
    getSongAuditState("publish").then(() => {
      renderData.goSellSongDialogVisible = true;
    });
    globalProperties?.logClickEvent("my_song_publish", {
      content_id: props.item?.song_id,
      entity: "my_song_publish",
      source:
        props.renderType == "createdetail"
          ? "detail"
          : props.listRenderType != "createdresult"
            ? "library"
            : "create",
    });
  }
};

// TODO：发行
const doRelease = async () => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  globalProperties?.logClickEvent("create_release", {
    entity: "release",
    origin: "create",
  });
  if (renderData.isGenerating) {
    return;
  }
  reRenderMore();
  if (props.item?.duration_milliseconds / 1000 / 60 < 2) {
    message.error({
      content: "Tracks must be at least 2 minutes long.",
      position: "top",
    });
    return;
  }
  // 未读状态上报
  if (props.item?.release_info?.unread) {
    releaseMessageReadStatusReport({
      song_id: props.item?.song_id,
      release_state: props.item?.release_info.release_state,
    }).then(() => {
      feedListDataStore.setTargetSongReleaseData(props.pitem, props.item, {
        ...props.item?.release_info,
        unread: false,
      });
    });
  }

  if (userDataStore.creditInfo.release_amount_left < 0) {
    message.error({
      content: "You've used up all your release opportunities.",
      position: "top",
    });
    return;
  }
  // feedListDataStore.showRelease(props.pitem, props.item);
  //   return;
  // feedListDataStore.showReleaseFormDialog();
  // return;
  // 未发行状态且不是会员显示弹窗
  // if (
  //   !props.item?.release_info?.release_state &&
  //   userinfo.value?.user?.vip_level_name != "pro"
  // ) {
  //   feedListDataStore.showRelease(props.pitem, props.item);
  //   return;
  // }

  // 统一获取最新的发行状态
  const res = await checkSongReleaseStatus({ song_id: props.item?.song_id });
  if (res.code === 200) {
    feedListDataStore.setReleaseData({
      ...res.data.song,
      ...res.data.release_info,
      submitted_at: res.data.submitted_at,
      release_state: res.data.release_state,
      item: props.item,
      pitem: props.pitem,
    });
  } else if (res.code === 6335) {
    // 6328 vip
    // message.error({
    //   content: $$t("create.release_need_vip"),
    //   position: "top",
    // });
    feedListDataStore.showRelease(props.pitem, props.item);
    return;
  } else if (res.code === 6329) {
    message.error({
      content: $$t("create.release_limit"),
      position: "top",
    });
    return;
  } else {
    message.error({
      content: $$t("create.release_failed"),
      position: "top",
    });
  }

  if (res.data.release_state <= 1 || !res.data.release_state) {
    feedListDataStore.showReleaseFormDialog();
    return;
  }
  // 审核失败需要先弹窗
  if (res.data.release_state === 2) {
    feedListDataStore.showReleaseAuditFailDialog(async () => {
      feedListDataStore.showReleaseFormDialog();
      return;
    }, res?.data.reject_message || "");
  }
  if (res.data.release_state == 3 || res.data.release_state == 4) {
    feedListDataStore.showReleaseResultDialog();
    if (res.data.release_state == 4) {
    }
  }
  if (res.data.release_state == 5) {
    feedListDataStore.showReleaseFailDialog(props.pitem, props.item);
  }
};

const doShare = (pitem, item, cb) => {
  reRenderMore();
  if ((props.pitem?.state == 2 && !props.item?.stream_key) || isDisableByAudit()) {
    return;
  }
  renderData.shareSuccessText = "";
  feedListDataStore
    .doShare(props.pitem, props.item)
    .then(() => {
      if (createRenderType.value == "mobile") {
        message.success({
          content: $$t("create.song_link_copied"),
          position: "top",
        });
      } else {
        renderData.shareSuccessText = $$t("create.song_link_copied");
        cb?.(renderData.shareSuccessText);
      }
      emits("share", props.pitem, props.item);
    })
    .catch((err) => {});
};

const doEditSongTitle = () => {
  pointerLogClickEvent("edit_song_title_and_cover");
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    .config.globalProperties;
  if (props.listRenderType == "createdresult") {
    globalProperties?.logCustomEvent("create_edit_song_title_and_cover", {
      content_id: props.item?.song_id,
    });
  } else {
    globalProperties?.logCustomEvent("library_edit_song_title_and_cover", {
      content_id: props.item?.song_id,
    });
  }

  reRenderMore();
  if (props.pitem?.state == 2 || [1, 3, 4].includes(props.item?.publish_state)) {
    return;
  }

  getSongAuditState("editSongInfo").then(() => {
    renderData.editSongInfoVisible = true;
  });
};
const doOpenSaleReviewFailedReason = () => {
  reRenderMore();
  showActionDialog({
    hideCancel: true,
    content: $$t("create.song_sale_review_failed_reason"),
    confirmLabel: $$t("create.i_knew"),
    confirm: (closeAction) => {
      closeAction();
    },
    cancel(closeAction) {
      closeAction();
    },
  });
};
const handleCompositionStart = () => {
  renderData.inputing = true;
};

const handleCompositionEnd = (e) => {
  renderData.inputing = false;
  onInput(e);
};
const onInput = (e) => {
  if (!renderData.inputing) {
    const value = e.target.value;
    e.target.value = e.target.value.slice(0, 50);
    renderData.title = e.target.value;
  }
};
const onBlur = () => {
  renderData.title = renderData.title.slice(0, 50);
  if (renderData.title.length > 0) {
    if (renderData.title == props.item?.title) {
      renderData.isEditTitle = false;
    } else {
      feedListApi
        .saveSongTitle({
          song_id: props.item?.song_id,
          title: renderData.title,
        })
        .then((res) => {
          if (res.code == 200) {
            props.item.title = renderData.title;
            renderData.isEditTitle = false;
            emits("editSongTitle", props.pitem, props.item);
          }
          if (res.code == 6316) {
            message.error({
              position: "top",
              content: $$t("create.generate_title_audit_failed"),
            });
          } else {
            renderData.isEditTitle = false;
            renderData.title = props.item?.title;
          }
        })
        .catch(() => {
          renderData.isEditTitle = false;
        });
    }
  } else {
    renderData.isEditTitle = false;
    renderData.title = props.item?.title;
  }
};
const changeUrlListenerListener = () => {
  const appContext = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext;
  renderData.isCurPlay =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
    renderData.url;
};

const checkUpdateUrl = () => {
  nextTick().then(() => {
    const url = getAudioUrl();
    if (props.item?.duration_milliseconds > 0) {
      renderData.duration = (props.item?.duration_milliseconds ?? 0) / 1000;
      if (renderData.duration == 0 && renderData.url.includes("stream_key=") > -1) {
        renderData.duration = 0;
      }
      renderData.durationText = mediaUtil.formatTime(renderData.duration);
    }
    renderData.url = getAudioUrl();
    renderData.title = props.item?.title;
    nextTick().then(() => {
      refPlayer.value?.checkAudioStatus();
      changeUrlListenerListener();
    });
  });
};

watch(
  () => isDoEditSong.value,
  (newValue) => {
    doTempToggleGlobalPlay(isDoEditSong.value);
  }
);

watch(
  () => {
    return globalPlayDataStore.curPlayData;
  },
  () => {
    checkUpdateUrl();
    refPlayer.value?.checkAudioStatus();
  }
);
watch(
  () => props.item,
  (newValue) => {
    checkUpdateUrl();
    refPlayer.value?.checkAudioStatus();
    renderData.hasPlayed = props.item?.is_played ?? false;
  }
);
watch(
  () => props.pitem,
  (newValue) => {
    renderData.isGenerating =
      props.renderType == "createdetail"
        ? !/\.[0-9A-Za-z]{1,}$/.test(props.item.mp3_url ?? "") && props.item.stream_key
        : props.pitem?.state == 2 && !!props.item.stream_key;
  }
);

watch(
  () => createRenderType.value,
  (newValue) => {
    if (newValue != "mobile") {
      renderData.moreDialogVisible = false;
    }
  }
);

const onResize = (entries) => {
  if (renderData.mouted) {
    renderData.itemWidth = refMoreListBox.value?.offsetWidth;
  }
};

onMounted(() => {
  renderData.mouted = true;
  const appContext = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  checkUpdateUrl();
  updateRenderProgress();
  onResize();
  renderData.resizeObserver = new ResizeObserver(onResize)?.observe(document.body);
});

onUnmounted(() => {
  const appContext = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releaseGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  renderData.mouted = false;
  renderData.resizeObserver?.disconnect();
});

watch(
  () => {
    return renderData.duration;
  },
  () => {
    renderData.durationText = mediaUtil.formatTime(renderData.duration);
  }
);
</script>
<style lang="scss" scope>
.audio-item {
  display: flex;
  align-items: center;
  padding: 12px 18px 12px 22px;
  justify-content: space-between;
  .audio-item-play-status {
    width: 8px;
    height: 8px;
    margin: 0 6px 0 -14px;
    border-radius: 20px;
    background: rgb(148, 173, 255); // #ff5f74;
  }
  .audio-item-op {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    /* border: 1px solid #ffffff; */
    i {
      height: 20px;
      width: 20px;
    }
    .isplay-true {
      background: url("@/assets/img/play-light-ico.png");
      background-size: 100% 100%;
    }
    .isplay-false {
      background: url("@/assets/img/pause-light-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-info-play-box {
    align-items: center;
  }
  .audio-item-info-wraper {
    align-items: center;
    width: 0;
    height: 100%;
    margin-left: 16px;
    .audio-item-info {
      width: 0;
      flex: 1;
    }
  }
  .audio-item-generate-progress-box {
    margin-top: 8px;
    max-width: 320px;
    display: flex;
    align-items: center;
    .audio-item-generate-progress-bar {
      width: 0;
      flex: 1;
      max-width: 350px;
      height: 6px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
    }
    .audio-item-generate-progress-bar-progress {
      height: 6px;
      border-radius: 12px;
      background: #94adff;
    }
    .audio-item-generate-progress-text {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #94adff;
      margin-left: 8px;
    }
  }

  .audio-item-decription-box {
  }

  .audio-item-cover-op-box {
    width: 72px;
    height: 72px;
    border-radius: 16px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
    .audio-item-cover-op {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .rotate-loading {
      width: 20px;
      height: 20px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      display: none;
    }

    .audio-item-cover-op-bg {
      height: 36px;
      width: 36px;
      border-radius: 100px;
      background: rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(8px);
      display: none;
    }

    .play {
      height: 20px;
      width: 20px;
      display: none;
    }
    .playing {
      display: none;
    }

    &.isplay-true {
      i {
        background: url("@/assets/img/pause-light-ico.png");
        background-size: 100% 100%;
        display: none;
      }
      .playing {
        display: block;
      }
      .audio-item-cover-op-bg {
        display: flex;
      }
      &:hover {
        i {
          display: block;
        }
        .playing {
          display: none;
        }
      }
    }

    &.isplay-false {
      i {
        background: url("@/assets/img/play-light-ico.png");
        background-size: 100% 100%;
        display: none;
      }
      .playing {
        display: none;
      }
      &:hover {
        .audio-item-cover-op-bg {
          display: flex;
        }
        i {
          display: block;
        }
      }
    }
    &.generate-loading {
      .audio-item-cover-op {
        background-color: rgba(0, 0, 0, 0.5);
      }
      .rotate-loading {
        display: block;
      }
      .audio-item-cover-op-bg {
        display: flex;
        background: transparent;
        backdrop-filter: unset;
      }
      &.isplay-true {
        .audio-item-cover-op {
          background-color: transparent;
          backdrop-filter: unset;
        }
        .audio-item-cover-op-bg {
          display: flex;
          background: rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(8px);
        }
        .playing {
          display: block !important;
        }
        i {
          display: none;
        }
        .rotate-loading {
          display: block;
        }
        &:hover {
          .rotate-loading {
            display: none;
          }
          i {
            display: block;
          }
          .playing {
            display: none !important;
          }
        }
      }
      &.isplay-false {
        i {
          display: none;
        }
        .playing {
          display: none;
        }
        .rotate-loading {
          display: block;
        }
        &:hover {
          .rotate-loading {
            display: none;
          }
          i {
            display: block;
          }
          .playing {
            display: none;
          }
        }
        &.generate-loading-play {
          .audio-item-cover-op {
            background-color: rgba(0, 0, 0, 0);
            backdrop-filter: unset;
          }
          .audio-item-cover-op-bg {
            background: rgba(0, 0, 0, 0.2);
            backdrop-filter: blur(8px);
          }
          .rotate-loading {
            display: none;
          }
          i {
            display: block !important;
          }
        }
      }
    }
    &.disabled {
      pointer-events: none;
    }
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &.active {
    background: rgba(148, 173, 255, 0.2);
    &:hover {
      background: rgba(148, 173, 255, 0.3);
    }
  }

  .audio-item-title-version {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    max-width: 100%;
    .audio-item-title {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      height: 24px;
      color: #ffffff;
      flex: 0 1 auto;
    }
    .audio-item-model,
    .audio-item-version,
    .audio-item-non-ownership,
    .audio-item-upload-type,
    .audio-item-edit-type {
      height: 14px;
      border-radius: 4px;
      opacity: 0.5;
      padding: 0px 3px;
      box-sizing: border-box;
      border: 1px solid rgba(255, 255, 255, 0.5);
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: normal;
      line-height: 12px;
      letter-spacing: 0em;
      color: rgb(255, 255, 255);
      margin-left: 6px;
      min-width: max-content;
    }

    .audio-item-version {
      display: none;
    }

    .audio-item-model {
      background: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(148, 173, 255, 0.5);
      color: #94adff !important;
      // backdrop-filter: blur(12px);
      opacity: 1 !important;
      &.O1,
      &.O2,
      &.O3,
      &.O4,
      &.O5 {
        border: 1px solid rgba(255, 241, 114, 0.5) !important;
        color: #fff75f !important;
        // backdrop-filter: blur(12px);
      }
    }

    .audio-item-published-tag {
      // background-image: url("@/assets/img/published-img.png");
      // background-size: 100% 100%;
      // background: linear-gradient(105deg, #4fdeff 0%, #e675ff 100%);
      height: 14px;
      border-radius: 2px;
      margin-left: 6px;
      min-width: 53px;
      .audio-item-published-tag-status {
        cursor: pointer;
        width: max-content;
        position: relative;

        .audio-item-published-tag-status-border {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 1px;
          background: rgba(255, 255, 255, 0.5);
          mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0) border-box;
          mask-composite: exclude;
        }

        .audio-item-published-tag-status-text {
          font-family: HarmonyOS Sans SC;
          font-size: 10px;
          font-weight: normal;
          line-height: 14px;
          text-align: center;
          background: rgba(255, 255, 255, 0.5);
          background-clip: text;
          padding: 0px 3px;
          color: transparent;
        }
      }
      .audio-item-published-tag-text {
        display: none;
        height: 12px;
        opacity: 0.5;
        padding: 0px 2px;
        box-sizing: border-box;
        font-family: HarmonyOS Sans SC;
        font-size: 0;
        font-weight: normal;
        line-height: 12px;
        letter-spacing: 0em;
        color: rgb(255, 255, 255);
        display: none;
      }
    }

    .audio-item-edit {
      width: 100%;
      height: 24px;
      padding: 1px 6px;
      background: rgba(255, 255, 255, 0.1);
      input {
        height: 20px;
        width: 100%;
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        color: #ffffff;
        background: transparent;
        border: none;
        outline: none;
        color: #ffffff;
        &::placeholder {
          color: rgba(255, 255, 255, 0.5) !important;
        }
      }
    }
  }

  .audio-item-decription {
    margin-top: 0px;
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.5);
    text-transform: capitalize;
    &.line-1 {
      margin-top: 1px;
    }
    &.line-2 {
      margin-top: 2px;
    }
    .audio-item-decription-duration-loading {
      width: 16px;
      height: 16px;
      background: url(@/assets/img/loading.png);
      background-size: 100% 100%;
    }
    .rotate-loading {
      width: 10px;
      height: 10px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      display: inline-block;
    }
  }
  .audio-item-info {
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    &.disabled-op {
      pointer-events: none;
    }
  }
  .audio-item-wave-box {
    height: 28px;
    margin: 0 20px;
    display: none;
    max-width: 30%;
  }

  .audio-item-wave-time {
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    height: 16px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 28px;
    display: none;
  }

  .audio-item-ico-btn,
  .audio-item-ops-btn-more {
    height: 32px;
    min-width: 32px;
    border-radius: 20px;
    margin-left: 8px;
    i {
      height: 16px;
      width: 16px;
    }
    &.ico-btn:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    @media (max-width: 768px) {
      &.ico-btn:hover {
        background: rgba(255, 255, 255, 0);
      }
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed !important;
      pointer-events: none;
      &:hover {
        background: transparent;
      }
    }
  }

  .audio-item-more-box,
  .audio-item-ops-btn-more {
    min-width: 32px;
    height: 32px;
    position: relative;
    .audio-item-ico-btn {
      margin-left: 0;
    }
    .audio-item-more-list-box {
      position: absolute;
      z-index: 1;
      display: none;
      &.position-t {
        bottom: 20px;
        right: 0;
        padding: 0 0 20px 0;
      }

      &.position-b {
        top: 20px;
        right: 0;
        padding: 20px 0 0 0;
      }
    }

    &:hover {
      .audio-item-more-list-box {
        display: block;
      }
    }
  }
  .audio-item-btn-publish {
    .custom-button .el-button {
      min-width: 94px;
    }
  }
  .audio-item-like-status {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
    }
    i.like-true {
      background: url("@/assets/img/praise-high-ico-white.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-unlike-status {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
    i.unlike-true {
      background: url("@/assets/img/praise-high-ico-white.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-share {
    i {
      background: url("@/assets/img/share-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-publish {
    i {
      background: url("@/assets/img/publish-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-published {
    i {
      background: url("@/assets/img/published-ico.svg");
      background-size: 100% 100%;
    }
  }

  .audio-item-feedback {
    i {
      background: url("@/assets/img/feedback-ico-white.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-more-btn {
    i {
      background: url("@/assets/img/more-ico.png");
      background-size: 100% 100%;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0%;
      color: #ffffff;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    &.disabled {
      pointer-events: none;
      &:hover {
        background: transparent;
      }
    }
    &.audio-item-more-btn-edit {
      width: max-content;
      padding: 0 12px;
      min-width: 80px;
      background: rgba(255, 255, 255, 0.1);
      i {
        background: url("@/assets/img/edit-more-ico.png");
        background-size: 100% 100%;
        margin: 0 6px 0 0;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    &.audio-item-more-btn-download {
      i {
        background: url("@/assets/img/download-more-ico.png");
        background-size: 100% 100%;
      }
    }
  }
  .audio-item-btn,
  .audio-item-like-status,
  .audio-item-more {
    margin-left: 8px;
    .unread {
      width: 10px;
      height: 10px;
      display: inline-block;
      position: absolute;
      right: 0;
      top: 0;
      background: #ff5f74;
      border-radius: 50%;
    }
  }

  .audio-item-ops-btn-more {
    height: 32px;
    width: 32px;
    border-radius: 20px;
    margin-left: 8px;
    cursor: pointer;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    i {
      background: url("@/assets/img/more-ico.png");
      background-size: 100% 100%;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    @media (max-width: 768px) {
      &:hover {
        background: rgba(255, 255, 255, 0);
      }
    }
  }
  .audio-item-ops-btn-more {
    display: none;
  }

  &.audio-item-mobile--mysong,
  &.audio-item-mobile--likemysong {
    .audio-item-decription-duration {
      display: unset;
    }
    .audio-item-wave-time {
      display: none;
    }
    .audio-item-wave-box {
      display: block;
    }
  }
  &.audio-item-mobile {
    padding: 12px 16px 12px 20px;
    .audio-item-play-status {
      margin: 0 6px 0 -14px;
    }
    .audio-item-info-op-box {
      margin-top: 6px;
    }
    .audio-item-more-btn {
      &.audio-item-more-btn-edit {
        margin-left: 0;
        i {
          height: 14px;
          width: 14px;
        }
      }

      span {
        font-size: 12px;
        line-height: 22px;
      }
    }

    .audio-item-cover-op-box {
      width: 68px;
      height: 68px;
      border-radius: 16px;
      .audio-item-cover-op-bg {
        display: flex;
      }
      &.isplay-false {
        i {
          display: block;
        }
      }
      &.isplay-true {
        &:hover {
          i {
            display: none;
          }
          .playing {
            display: block;
          }
        }
      }
      &.generate-loading {
        .rotate-loading {
          display: block;
        }
        &.isplay-true {
          .playing {
            display: none;
          }
          i {
            display: none;
          }
          .rotate-loading {
            display: block;
          }
          &:hover {
            .rotate-loading {
              display: none;
            }
            i {
              display: block;
            }
            .playing {
              display: none;
            }
          }
        }
        &.isplay-false {
          i {
            display: none;
          }
          .playing {
            display: none;
          }
          .rotate-loading {
            display: block;
          }
          &:hover {
            .rotate-loading {
              display: none;
            }
            i {
              display: block;
            }
            .playing {
              display: none;
            }
          }
        }
      }
    }

    .audio-item-info-wraper {
      flex-direction: column;
      margin-left: 12px;
      .audio-item-info {
        width: 100%;
      }
      .audio-item-info-op-box {
        width: 100%;
        .custom-button,
        .el-button {
          height: 28px;
          font-size: 12px;
          min-width: 80px;
        }
        .audio-item-ico-btn,
        .audio-item-ops-btn-more {
          height: 28px;
          min-width: 28px;
          border-radius: 20px;
          margin-left: 8px;
        }
        .audio-item-more-box {
          margin-left: 0;
        }
        .audio-item-more-btn-edit {
          margin-left: 0;
        }
      }
    }

    .audio-item-title-version {
      .audio-item-title {
        font-size: 14px;
        line-height: 16px;
        height: 16px;
      }
      .audio-item-version,
      .audio-item-non-ownership,
      .audio-item-upload-type,
      .audio-item-edit-type {
        height: 14px;
        border-radius: 4px;
        opacity: 0.5;
        padding: 0px 3px;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.5);
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 12px;
        letter-spacing: 0em;
        color: rgb(255, 255, 255);
        margin-left: 6px;
      }
    }
    .audio-item-decription-box {
      font-size: 10px;
      line-height: 12px;
      .audio-item-decription {
        margin: 0;
      }
      .audio-item-decription.line-2 {
        display: none;
      }
    }

    .audio-item-btn {
      &:first-child {
        margin-left: 0;
      }
    }
    .audio-item-ops-btn-more {
      display: none;
    }
    &.audio-item-mobile--mysong,
    &.audio-item-mobile--likemysong {
      .audio-item-decription-duration {
        display: unset;
      }
      .audio-item-wave-time {
        display: none;
      }
      .audio-item-wave-box {
        display: none;
      }
    }
  }
}
.audio-item-more-list {
  padding: 0px 0;
  min-width: 320px;
  width: max-content;
  border-radius: 8px;

  background: rgba(191, 178, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0);
  backdrop-filter: blur(20px);
  padding: 8px 0;
  &.audio-item-more-list-cn {
    min-width: 300px;
  }

  .audio-item-more-list-item {
    padding: 0 12px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 38px;
    color: #ffffff;
    position: relative;
    margin: 0 8px;
    border-radius: 8px;
    align-items: center;
    .audio-item-more-list-item-main {
      display: flex;
      align-items: center;
    }
    img {
      margin-right: 8px;
      height: 16px;
      width: 16px;
    }

    span {
      display: block;
      flex: 1 1 auto;
    }
    &.disabled {
      pointer-events: none;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  label.vip_plan {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: linear-gradient(135deg, #ffe08b 0%, #fff7d0 47.89%, #ffe08b 100%);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    em {
      font-style: italic;
      font-size: 12px;
      font-weight: 600;
      color: #402c00;
    }
  }
  label.vip_plan_basic {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: linear-gradient(100deg, #6cf 5.09%, #a9e2ff 49.09%, #6cf 93.1%);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    em {
      font-style: italic;
      font-size: 12px;
      font-weight: 600;
      color: #215385;
    }
  }
  label.beta_plan {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: rgba(255, 255, 255, 0.12);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-style: italic;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
  }

  .vip_plan-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .audio-item-more-list-item:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  .audio-item-more-list-item-sale-box {
    .bubble-box {
      display: inline-block;
      margin-left: 8px;
    }
    i {
      border-radius: 20px;
      height: 20px;
      width: 20px;
      background: url("@/assets/img/question-ico.png");
      background-size: 100% 100%;
    }
  }
  .disabled {
    pointer-events: none;
    color: rgba(255, 255, 255, 0.5);
  }
}
.el-popover.el-popper.audio-item-more-popover {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  color: unset;
  font-size: unset;
  line-height: unset;
  min-width: max-content;
  word-wrap: break-word;
  padding: unset;
  .el-popper__arrow {
    display: none;
  }
}
@media (max-width: 1200px) {
  .audio-item {
    .audio-item-wave-box {
      display: none !important;
    }
  }
}
</style>
